import { defineComponent, computed, watch } from 'vue';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { SkuData } from '~mall/model/store/modules/ticket';
import { getStylesBinder } from '~mall/common/utils/styles';
import styles from './index.module.less';
import CardListItem from '../bike/CardListItem';
import GoodListItem from '../GoodListItem';
import { TWO_WHEELS_CATEGORY } from '~mall/common/constants/commonConstants';
import { CategoryBizId } from '~mall/constants/bike';
import { appQueryConfig } from '~mall/common/utils/url';
import store from '~mall/model/store';

const cx = getStylesBinder(styles);

export default defineComponent({
  name: 'CommonRecommend',
  props: {
    ridePaySuccess: {
      type: Function,
      required: false,
    },
  },
  emits: ['loaded'],
  setup: (props, { emit }) => {
    // 从store中获取超值推荐数据
    const goodList = computed(() => store.state.ticket.greatValueModule || []);
    const algoTraceID = computed(() => store.state.ticket.greatValueTraceId || '');

    // 监听数据变化，触发曝光埋点
    watch(
      goodList,
      (newVal, oldVal) => {
        if (newVal && newVal.length > 0) {
          // 商品埋点
          UBT.moduleExpose({
            pageId: 'platform_couponmall',
            categoryId: 'platform',
            moduleId: 'platform_supervaluerecommend',
            contentId: 'platform_supervaluerecommend',
            exposureTimes: '1',
            businessInfo: {
              algoTraceID: algoTraceID.value,
              skuId: newVal.map((item: SkuData) => item.skuId).filter(Boolean),
              adsource: appQueryConfig.adsource,
              sku_name: newVal.map((
                item: SkuData,
              ) => (
                item.twoWheelCard ? item.twoWheelCard.showName : item.goodsName
              )).filter(Boolean),
            },
          });
          // 通知父组件数据已加载
          emit('loaded');
        } else if (oldVal !== undefined) {
          // oldVal !== undefined 说明不是首次执行，而是数据确实为空
          emit('loaded');
        }
      },
      { immediate: true },
    );

    const handleClick = (good: SkuData) => {
      const { twoWheelCard } = good;
      if (twoWheelCard) {
        // 两轮商品没有spuid  所以统一不埋spuid只埋skuid
        UBT.clickButton({
          pageId: 'platform_couponmall',
          buttonName: 'platform_supervaluerecommend',
          categoryId: 'platform',
          businessInfo: {
            algoTraceID: algoTraceID.value,
            skuId: good.skuId,
            adsource: appQueryConfig.adsource,
            sku_name: twoWheelCard.showName,
          },
        });
      } else {
        UBT.clickButton({
          pageId: 'platform_couponmall',
          buttonName: 'platform_supervaluerecommend',
          categoryId: 'platform',
          businessInfo: {
            algoTraceID: algoTraceID.value,
            skuId: good.skuId,
            adsource: appQueryConfig.adsource,
            sku_name: good.goodsName,
          },
        });
      }
    };

    return () => {
      if (goodList.value.length === 0) {
        return null;
      }

      return (
        <div class={cx('common-recommend')}>
          <img
            class={cx('common-recommend-icon')}
            src="https://m.hellobike.com/5962472a_Group%202090054607.png"
            alt="超值推荐"
          />
          <div class={cx('common-recommend-list')}>
            {goodList.value.map((good: SkuData, goodIndex: number) => {
              const { twoWheelCard, categoryId, categoryName } = good;

              if (twoWheelCard) {
                const { channelCode, ...pkgData } = twoWheelCard || {};
                const data = {
                  ...pkgData,
                  categoryName,
                };
                return (
                  <div key={goodIndex} class={cx('good')} onClick={() => handleClick(good)}>
                    <CardListItem
                      data={data}
                      channelCode={channelCode}
                      bizId={CategoryBizId[categoryId as TWO_WHEELS_CATEGORY]}
                      paySuccessCb={props.ridePaySuccess as any}
                      categoryName={categoryName}
                      tabCategoryName='超值精选'
                      categoryId={categoryId}
                      traceId={algoTraceID.value}
                      skuIndex={goodIndex}
                      highRecm={true}
                    />
                  </div>
                );
              }

              return (
                <div key={goodIndex} class={cx('good')} onClick={() => handleClick(good)}>
                  <GoodListItem
                    skuData={good}
                    skuIndex={goodIndex}
                    categoryName={categoryName}
                    tabCategoryName='超值精选'
                    categoryId={categoryId || ''}
                    traceId={algoTraceID.value}
                    highRecm={true}
                  />
                </div>
              );
            })}
          </div>
        </div>
      );
    };
  },
});
